import RegionSelector, {
    RegionSelectorProps,
} from 'components/regions/regionSelector';

import { HospitalCenterRequests } from 'apollo';
import { useCallback } from 'react';
import { HospitalCenterSchema } from '__generated__/graphql';

type ChildrenProps = Omit<
    RegionSelectorProps,
    'onRegionChange' | 'onRegionRemove'
>;

export type HospitalRegionSelectorProps = ChildrenProps & {
    hospital: HospitalCenterSchema;
};

export default function HospitalRegionSelector(
    props: HospitalRegionSelectorProps
) {
    const onRegionChange = useCallback(async (regionId: number) => {
        await HospitalCenterRequests.updateHospitalCenter({
            _id: props.hospital._id,
            name: props.hospital.name,       
            address: props.hospital.address,
            regionId,
        });
    }, []);

    const onRegionRemove = useCallback(async () => {
        await HospitalCenterRequests.removeHospitalRegion(props.hospital._id);
    }, []);

    return (
        <RegionSelector
            availableRegions={props.availableRegions}
            initialRegionId={props.initialRegionId}
            onRegionChange={onRegionChange}
            onRegionRemove={onRegionRemove}
        />
    );
}
